import { useEffect, useRef } from "react";

const VideoControls = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const updateVideoRef = () => {
      videoRef.current = document.querySelector("video");
      if (!videoRef.current) {
        console.error("Video element not found!");
      }
    };

    updateVideoRef(); // Set the initial video reference

    const frameRate = 30;
    let debounce = false;

    const handleKeyDown = (event) => {
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA" ||
        event.target.tagName === "TEXTFIELD" ||
        event.metaKey || event.ctrlKey || event.altKey || event.shiftKey
      ) {
        return; // Allow normal typing in input/textarea fields
      }

      if (!videoRef.current) {
        console.error("No video element found!");
        return;
      }

      if (debounce) return;
      debounce = true;

      setTimeout(() => {
        debounce = false;
      }, 100);

      switch (event.key.toLowerCase()) {
        case " ":
          event.preventDefault();
          videoRef.current.paused ? videoRef.current.play() : videoRef.current.pause();
          break;

        case "c":
          event.preventDefault();
          videoRef.current.pause();
          videoRef.current.currentTime += 1 / frameRate; // Seek forward by one frame
          break;

        case "z":
          event.preventDefault();
          videoRef.current.pause();
          videoRef.current.currentTime = Math.max(0, videoRef.current.currentTime - 1 / frameRate); // Seek backward by one frame
          break;

        default:
          break;
      }
    };

    // Attach keydown event listener
    window.addEventListener("keydown", handleKeyDown);

    // Re-update video reference on DOM changes
    const observer = new MutationObserver(() => {
      updateVideoRef();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Clean up
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      observer.disconnect();
    };
  }, []);

  return null; // No UI needed, this component handles logic
};

export default VideoControls;